<template>
  <el-dialog
    :title="activityTitle"
    :visible.sync="dialogVisible"
    top="29vh"
    width="700px"
    :lock-scroll="false"
    :close-on-click-modal="false"
    @close="closeDialog"
  >
    <div v-loading="isLoading">
      <div v-if="canCancel" style="padding-bottom: 30px">
        <el-alert
          title="取消活动"
          description="是否取消当前活动？取消后可再次发布"
          type="warning"
          :closable="false"
          show-icon
        >
        </el-alert>
      </div>
      <el-form
        ref="ruleForm"
        class="ruleForm"
        :model="form"
        :rules="rules"
        label-position="right"
        label-width="80px"
        :disabled="!canCancel"
      >
        <el-form-item label="备注：" prop="reason">
          <el-input
            v-model="form.reason"
            type="textarea"
            :autosize="{ minRows: 5 }"
            :placeholder="canCancel ? '可填写取消原因' : ''"
            maxlength="200"
            show-word-limit
            resize="none"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <p v-if="canCancel" class="submit fn-text-center">
        <el-button type="primary" @click="handleConfirm('ruleForm')"
          >确定</el-button
        >
      </p>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    activityTitle: {
      type: String,
      required: true
    },
    activityId: {
      type: String,
      required: true
    },
    canCancel: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      dialogVisible: true,
      form: {
        reason: ""
      },
      rules: {},
      isLoading: false
    };
  },
  created() {
    if (!this.canCancel) {
      this.loadInfo();
    }
  },
  methods: {
    // 关闭弹框后回调
    closeDialog() {
      // 传递关闭上一级
      this.$emit("close", true);
    },
    handleConfirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadCancel();
        }
      });
    },
    loadCancel() {
      this.isLoading = true;
      this.$api("activity", "cancelMessage", {
        id: this.activityId,
        ...this.form
      }).then((res) => {
        this.isLoading = false;
        this.$message({
          message: res.message,
          type: res.code === 0 ? "success" : "error"
        });
        if (res.code === 0) {
          this.$emit("complete", true);
        }
      });
    },
    // 加载数据接口
    loadInfo() {
      this.$api("activity", "getCancelReason", { id: this.activityId }).then(
        (res) => {
          const { code, message } = res;
          if (code === 0) {
            this.form.reason = res.dataList[0].cancelReason;
          } else {
            this.$message.error(message);
          }
        }
      );
    }
  }
};
</script>

<style lang="less" scoped></style>
